export default __webpack_public_path__ + "opcomobilites.1333386.png";